/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc
 */

export const getApplicationGovernanceRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getApplicationGovernance',
  auth: 'app',
  fingerprint: '3xbWAJg_KgN-Z2xqjxPZpB27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enableApplicationInstallableRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'enableApplicationInstallable',
  auth: 'app',
  fingerprint: '9wyW9htCBhKgAXvxlhYS_x27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApprovedApplicationPaginatedRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getApprovedApplicationPaginated',
  auth: 'app',
  fingerprint: 'B8aIGUXBuJ7SL8Jy4sGmmh27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const revokeApprovalRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'revokeApproval',
  auth: 'app',
  fingerprint: '7Rqz1UTuWIWbEYoqbLs8zR27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppGovernancePermissionsRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getAppGovernancePermissions',
  auth: 'app',
  fingerprint: 'wFHKhHlUSwIwEg-XRfZVYx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const approveAppGovernancePermissionsRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'approveAppGovernancePermissions',
  auth: 'app',
  fingerprint: 'vuASiqtzY6txbGjZI_99ph27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAllowedAppPermissionsRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'updateAllowedAppPermissions',
  auth: 'app',
  fingerprint: 'eO8AOUdsLSWoEc_IQm2VEx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAllowedEntityTypeAndIdsRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'updateAllowedEntityTypeAndIds',
  auth: 'app',
  fingerprint: 'mv_lhhpfink35O1GBpf7dx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApprovableAppsWithStatusRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getApprovableAppsWithStatus',
  auth: 'app',
  fingerprint: 'Bupb0O2ndZzT8PU-QtxGuB27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const removeAppPermissionsFromInstallsRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'removeAppPermissionsFromInstalls',
  auth: 'app',
  fingerprint: '59stX4C8Kpg5UYCqgfD1vx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOrCreateConnectedAppObjectRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getOrCreateConnectedAppObject',
  auth: 'app',
  fingerprint: 'r19Dca9_SQQn4XGE-rzJUx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppsGovernanceStatusRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getAppsGovernanceStatus',
  auth: 'app',
  fingerprint: 'CGG4px4t4UgfPifa9l9hjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApprovedApplicationsForUserPagedRpc = {
  serviceName: 'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getApprovedApplicationsForUserPaged',
  auth: 'app',
  fingerprint: 'ZXcVSBEcf2B7Stq7wVnXVh27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};